import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Background from './components/Background';
import Contact from './components/Contact';
import AdditionalSupport from './components/AdditionalSupport';
import Articles from './components/Articles';
import Location from './components/Location';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';

function Home() {
  return (
    <div className="App bg-[#FAF9F6]">
      <Header />
      <main>
        <Hero />
        <About />
        <Background />
        <Contact />
        <AdditionalSupport />
        <Articles />
        <Location />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<><PrivacyPolicy /><Footer /></>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
